import { Controller } from "@hotwired/stimulus";
import { CsrfToken } from "../shared/csrf_token";
import { TurboStreamHeaders } from "../shared/turbo_stream_headers";

// Connects to data-controller="resumin--image-conversion-preview"
export default class extends Controller {
  static targets = ["fileInput"];
  // valuesには定義していないが、プレビューを表示する位置のIDを以下の要素で指定する。
  // resumin--image-conversion-preview-replace-tag-id-value

  connect() {
    CsrfToken(this);
    TurboStreamHeaders(this);
  }

  selectFile(e) {
    e.preventDefault();
    this.fileInputTarget.click();
  }

  preview(e) {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);
    formData.append(
      "replace_tag_id",
      e.target.dataset["resumin-ImageConversionPreviewReplaceTagIdValue"]
    );

    fetch("/image_conversion/preview", {
      method: "POST",
      body: formData,
      headers: {
        ...this.csrfToken(),
        ...this.turboStreamHeaders(),
      },
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((errorMessage) => {
            throw new Error(
              errorMessage.error || "Network response was not ok"
            );
          });
        }
        return response.text();
      })
      .then((html) => {
        Turbo.renderStreamMessage(html);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.fileInputTarget.value = "";
        alert(error.message);
      });
  }

  remove(e) {
    e.preventDefault();

    const formData = new FormData();
    formData.append(
      "replace_tag_id",
      e.target.dataset["resumin-ImageConversionPreviewReplaceTagIdValue"]
    );

    fetch("/image_conversion", {
      method: "DELETE",
      body: formData,
      headers: {
        ...this.csrfToken(),
        ...this.turboStreamHeaders(),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then((html) => {
        Turbo.renderStreamMessage(html);
        this.fileInputTarget.value = "";
        const event = new CustomEvent("imageConversionPreview:remove", {
          detail: { e: e },
        });

        this.fileInputTarget.dispatchEvent(event);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }
}
